import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Calendar, MessageSquare } from "lucide-react";
import { CONTACT } from "@/data/site";

/**
 * Sticky bottom mobile CTA (Book + Text). Hidden on the booking page so it never
 * covers the scheduler. Respects iPhone safe-area insets.
 */
export default function StickyBook() {
  const { pathname } = useLocation();
  if (pathname === "/book") return null;

  return (
    <div
      className="lg:hidden fixed inset-x-0 bottom-0 z-40 border-t border-gold/25 bg-onyx/95 backdrop-blur-md"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-2 gap-2 p-2.5">
        <Link
          to="/book"
          className="btn-gold inline-flex items-center justify-center gap-2 py-3 text-xs tracking-[0.2em] uppercase"
        >
          <Calendar size={16} /> Book Now
        </Link>
        <a
          href={CONTACT.smsHref}
          className="btn-gold-outline inline-flex items-center justify-center gap-2 py-3 text-xs tracking-[0.2em] uppercase"
        >
          <MessageSquare size={16} /> Text Us
        </a>
      </div>
    </div>
  );
}
